import { getCorrelationIdFromStorage } from '@/auth/infrastructure/utils/correlationIdUtils';
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import type { ITokenProvider } from './token-provider.interface';

/** Raw JWT from storage; strip a leading `Bearer ` so we never send `Bearer Bearer …`. */
export function normalizeAccessTokenForBearerHeader(raw: string | undefined): string | undefined {
  if (raw == null || raw.trim() === '') return undefined;
  const t = raw.trim();
  return t.toLowerCase().startsWith('bearer ') ? t.slice(7).trim() : t;
}

/**
 * Shared request interceptor for Orval-generated clients (main REST + User Management, etc.).
 * Attaches `Authorization: Bearer` and `X-correlation-ID` when present.
 */
export function attachOrvalAuthRequestInterceptor(client: AxiosInstance, getTokenProvider: () => ITokenProvider | null): void {
  client.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      try {
        const token = normalizeAccessTokenForBearerHeader(getTokenProvider()?.getToken());
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        const correlationId = getCorrelationIdFromStorage();
        if (correlationId) {
          config.headers['X-correlation-ID'] = correlationId;
        }
      } catch (error) {
        console.error('Failed to get auth token (Orval axios):', error);
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}
